import { render, staticRenderFns } from "./TheFeedbackModal.vue?vue&type=template&id=45dce7f8&"
import script from "./TheFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./TheFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports